// extracted by mini-css-extract-plugin
export default {"container":"WindowTrim_container__8stDv","productListContainer":"WindowTrim_productListContainer__l2xoj","productGrid":"WindowTrim_productGrid__gFUwx"};